import React, { useState } from "react";
import { Fab } from "@mui/material";
import { styled } from "@mui/system";

import { ReactComponent as Plus } from "../assets/plus.svg";
import { getCustomPrompts } from "../lib/helper";

function FloatingMenu({ onClick }) {
  const [showButtons, setShowButtons] = useState(false);

  const handleClick = (e) => {
    e.preventDefault();
    setShowButtons(!showButtons);
  };

  const onOptionChoose = (e, option) => {
    setShowButtons(!showButtons);
    onClick(e, option);
  };

  return (
    <div
      style={{ marginLeft: 10 }}
    >
      <Fab
        color="transparent"
        aria-label="add"
        onClick={handleClick}
        size={"small"}
        style={{
          backgroundColor: "transparent",
        }}
      >
        <Plus />
      </Fab>

      {/* Additional FAB buttons */}
      {showButtons && (
        <>
          <AnimatedButton
            style={{
              position: "absolute",
              bottom: "80px",
              left: "0px",
              animation: "slideIn 0.3s ease-out",
            }}
            variant="extended"
            onClick={(e) => onOptionChoose(e, getCustomPrompts.patientStatus)}
          >
            Patient Status
          </AnimatedButton>
          <AnimatedButton
            style={{
              position: "absolute",
              bottom: "140px",
              left: "0px",
              animation: "slideIn 0.3s ease-out",
            }}
            variant="extended"
            onClick={(e) => onOptionChoose(e, getCustomPrompts.admissionStatus)}
          >
            Admission Status
          </AnimatedButton>
          <AnimatedButton
            style={{
              position: "absolute",
              bottom: "200px",
              left: "0px",
              animation: "slideIn 0.3s ease-out",
            }}
            variant="extended"
            onClick={(e) => onOptionChoose(e, getCustomPrompts.documentation)}
          >
            Documentation
          </AnimatedButton>
        </>
      )}

      {/* Animations using CSS */}
      <style>
        {`
          @keyframes slideIn {
            from {
              opacity: 0;
              transform: translateY(20px);
            }
            to {
              opacity: 1;
              transform: translateY(0);
            }
          }
        `}
      </style>
    </div>
  );
}

// Styled component for the additional buttons
const AnimatedButton = styled(Fab)({
  transition: "all 0.3s ease",
});

export default FloatingMenu;
